import { Box, Stack } from "@mui/material";
import { Component } from "react";
import { withLocale, WithLocaleProps } from "../providers/LocaleProvider";
import AttributesIcon from "../resources/images/icons-attribute.svg";

interface PlaceholderProps extends WithLocaleProps {
  text?: string | { primary: React.ReactNode; secondary?: React.ReactNode };
  icon?: React.ReactNode;
  sx?: any;
  className?: string;
  primaryTextSize?: string;
  secondaryTextSize?: string;
  spacing?: number;
}

class PlaceholderBase extends Component<PlaceholderProps, any> {
  static defaultProps = {
    icon: <AttributesIcon />,
    primaryTextSize: "20px",
    secondaryTextSize: "16px",
    spacing: 3
  };

  render() {
    const { icon, text, sx, className, primaryTextSize, secondaryTextSize, spacing, translate } =
      this.props;
    const displayText = text ?? translate("common.noRows");

    return (
      <Stack
        className={"klayo-placeholder" + (className ? " " + className : "")}
        spacing={spacing}
        sx={sx}
      >
        <div className='klayo-placeholder_icon'>{icon}</div>
        <div className='klayo-placeholder_text'>
          {displayText && typeof displayText === "object" && "primary" in displayText ? (
            <div>
              <Box className='klayo-placeholder_text_primary' sx={{ fontSize: primaryTextSize }}>
                {displayText.primary}
              </Box>
              <Box
                className='klayo-placeholder_text_secondary'
                sx={{ fontSize: secondaryTextSize }}
              >
                {displayText.secondary}
              </Box>
            </div>
          ) : (
            displayText
          )}
        </div>
      </Stack>
    );
  }
}

export const Placeholder = withLocale(PlaceholderBase);
